





























import { Vue, Component, PropSync } from 'vue-property-decorator';
interface Option {
  label: string;
  value: string | number;
}
interface FormItem {
  label: string;
  type: string;
  options?: Option[];
}

@Component
export default class KEditTable extends Vue {
  @PropSync('list') syncList!: FormItem[];

  tableData: any[] = [];

  addList() {
    this.tableData.push({});
  }
}
